export const enUS = {
    values: {
        'well-operations-navigation': 'well-operations-navigation',
        'Well Operations Navigation': 'Well Operations Navigation',
        'This plugin able to navigation in all well operations': 'This plugin able to navigation in all well operations'
    }
}
